const styles = theme => ({
    root: {
        marginLeft: '-10rem',
        marginRight: '120px',
        backgroundColor: '#1D1D1D',
        width: 'fit-content',
        paddingTop: '50px',
        position: 'relative',
        paddingLeft: '10rem',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: '22px',
        paddingBottom: '30px',
        boxShadow: '5px 5px 30px rgba(0, 0, 0, 0.2)',
        [theme.breakpoints.up(theme.breakpoints.values.xs + 2000)]: {
            paddingLeft: '7rem',
            marginLeft: '-7rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
            paddingLeft: '80px',
            marginLeft: '-80px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            flexDirection: 'column',
            width: 'calc(100% + 2rem)',
            margin: '0',
            marginLeft: '-1rem',
            marginTop: '40px',
            padding: '1rem'
        }
    },
    span: {
        flexBasis: '60%',
        width: '60%',
        marginRight: '50px',
        zIndex: 10,
        backgroundColor: '#1D1D1D',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1250)]: {
            marginRight: 0
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            flexBasis: '100%',
            width: '100%',
            marginRight: '0'
        }
    },
    h1: {
        fontFamily: 'Montserrat',
        color: 'white',
        fontSize: '24px',
        fontWeight: '700',
        letterSpacing: '0.01em',
        lineHeight: '28.8px',
        margin: 0,
        marginBottom: '50px',
        maxWidth: '25ch',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            display: 'none'
        }
    },
    btn: {
        borderRadius: '0',
        border: '2px solid #FFC636',
        padding: '12px 20px',
        color: '#FFC636',
        fontFamily: 'Montserrat',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '17px',
        margin: '0',
        marginTop: '50px',
        textTransform: 'none',
        whiteSpace: 'pre',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            width: '100%'
        }
    },
    fadeImg: {
        opacity: '0.2 !important',
        filter: 'grayscale(1)'
    },
    blockRevealWrapper: {
        marginTop: '-70px',
        alignSelf: 'flex-start',
        marginRight: '-114px',
        maxWidth: '665px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1200)]: {
            transform: 'scale(0.95)',
            transformOrigin: 'top left'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
            marginLeft: '-20px',
            zIndex: '10',
            transform: 'scale(0.91)',
            transformOrigin: 'top left'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            height: 'auto',
            transform: 'scale(1)',
            width: '100%',
            marginLeft: 0,
            marginTop: '40px',
            maxWidth: '100%'
        }
    },
    imgPicker: {
        transition: 'all 0.3s ease-in-out',
        opacity: 1,
        height: '100%',
        minWidth: '665px',
        filter: 'drop-shadow(5px 10px 50px rgba(0, 0, 0, 0.3))',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1080)]: {
            height: 'auto',
            width: '100%',
            minWidth: '100%'
        }
    }
})

export default styles